import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { Tippy as TippyComponent } from "../../node_modules/.pnpm/vue-tippy@6.5.0_vue@3.5.13_typescript@4.9.5_/node_modules/vue-tippy/dist/vue-tippy.esm-browser.es.js";
import { defineComponent, watch, onMounted, resolveComponent, openBlock, createBlock, withCtx, createVNode, createCommentVNode, getCurrentInstance } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref, unref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsTooltip",
  props: {
    placement: {
      type: String,
      default: "top"
    },
    maxWidth: {
      type: [String, Number],
      default: "100%"
    },
    // Only show the tooltip when the parent is overflowing
    onOverflowOnly: {
      type: Boolean,
      default: false
    },
    onDark: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [0, 14]
    },
    modelValue: {
      type: Boolean,
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  setup(__props, { expose: __expose }) {
    var _a;
    const props = __props;
    const instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
    const enabled = ref(true);
    const tippyEl = ref(null);
    watch(() => props.modelValue, (newValue) => {
      if (!tippyEl.value) {
        return;
      }
      newValue ? tippyEl.value.show() : tippyEl.value.hide();
    });
    onMounted(async () => {
      if (props.onOverflowOnly) {
        const parent = instance.$el.parentNode;
        if (parent) {
          enabled.value = parent.scrollWidth > parent.clientWidth;
        }
      }
    });
    const show = () => {
      tippyEl.value.show();
    };
    const hide = () => {
      tippyEl.value.hide();
    };
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return enabled.value ? (openBlock(), createBlock(unref(TippyComponent), {
        key: 0,
        ref_key: "tippyEl",
        ref: tippyEl,
        to: "parent",
        interactive: true,
        duration: [350, 350],
        delay: [__props.delay, __props.hideDelay],
        "max-width": __props.maxWidth,
        placement: __props.placement,
        offset: __props.offset,
        "popper-options": {
          strategy: "fixed"
        },
        theme: __props.onDark ? "websupport-light" : "websupport",
        "hide-on-click": typeof __props.modelValue === "undefined",
        trigger: typeof __props.modelValue === "undefined" ? "mouseenter focus" : "manual"
      }, {
        default: withCtx(() => [
          createVNode(_component_portal_slot, {
            slot: _ctx.$slots.default,
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ]),
        _: 1
      }, 8, ["delay", "max-width", "placement", "offset", "theme", "hide-on-click", "trigger"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsTooltip.vue.es.js.map
